import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { db } from "../../../firebase";
import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";

const DOC_ID = "subscribe_discount_popup";

const quillModules = {
  toolbar: {
    container: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }, { direction: "rtl" }],
      ["link", "image", "video"],
      ["clean"],
    ],
  },
  clipboard: { matchVisual: true },
};

const quillFormats = [
  "header",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "blockquote",
  "code-block",
  "list",
  "indent",
  "align",
  "direction",
  "link",
  "image",
  "video",
];

export default function PopupEditorSubscribeDiscount() {
  const [value, setValue] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    const fetchPopup = async () => {
      try {
        const snap = await getDoc(doc(db, "popups", DOC_ID));

        if (snap.exists()) {
          setValue(snap.data()?.contentHtml || "");
        }
      } catch (e) {
        setError(e?.message || "Помилка завантаження");
      } finally {
        setLoaded(true);
      }
    };

    fetchPopup();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setError("");

    try {
      await setDoc(
        doc(db, "popups", DOC_ID),
        {
          title: "Попап підписки на знижку",
          key: "subscribe_discount_popup",
          locale: "uk",
          isActive: true,
          contentHtml: value,
          updatedAt: serverTimestamp(),
        },
        { merge: true },
      );
    } catch (e) {
      setError(e?.message || "Помилка збереження");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ maxWidth: 960, margin: "0 auto", padding: 16 }}>
      <h2 style={{ marginBottom: 8 }}>
        Редактор попапа: «Підписатися / отримати знижку»
      </h2>

      {!loaded ? (
        <div>Завантаження…</div>
      ) : (
        <>
          <ReactQuill
            theme="snow"
            value={value}
            onChange={setValue}
            modules={quillModules}
            formats={quillFormats}
            placeholder="Введіть текст для попапа підписки…"
          />

          {error && (
            <div style={{ color: "crimson", marginTop: 8 }}>{error}</div>
          )}

          <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
            <button onClick={handleSave} disabled={saving}>
              {saving ? "Зберігаю…" : "Зберегти"}
            </button>

            <button
              type="button"
              onClick={() => setValue("")}
              disabled={saving}
            >
              Очистити
            </button>
          </div>
        </>
      )}
    </div>
  );
}
